export class ResponseError extends Error {
  constructor (message) {
    super()
    this.name = 'ResponseError'
    this.message = message
  }
}
